var map = {
	"./en/faq.yml": 128,
	"./en/home.yml": 129,
	"./en/main.yml": 28,
	"./en/newsletter.yml": 130,
	"./en/subfaq.yml": 131,
	"./fr/faq.yml": 132,
	"./fr/home.yml": 133,
	"./fr/main.yml": 29,
	"./fr/newsletter.yml": 134,
	"./fr/subfaq.yml": 135
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 127;